// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"phoneButton-module--wrapper--3gsq7","open":"phoneButton-module--open--3UNp7","closed":"phoneButton-module--closed--2Gu2V","mobile":"phoneButton-module--mobile--23iWh"};